<script lang="ts">
  import { getContext } from "svelte";
  import type { Writable } from "svelte/store";
  import type { Tab } from "./types";

  export let id: string;
  export let title: string;

  const tabs = getContext<Writable<Tab[]>>("tabs");
  tabs.update((ts) => [...ts, { id, title }]);

  const activeTab = getContext<Writable<string>>("activeTab");
</script>

{#if id === $activeTab}
  <slot />
{/if}
